module.exports = __webpack_public_path__ + "static/media/hat-santa.43134e74.svg";